export default function install (Vue, options) {
  if (install.installed) return
  install.installed = true
  Object.defineProperty(Vue.prototype, '$wechat', {
    get () { return this.$root._wechat }
  })

  Object.defineProperty(Vue.prototype, '$wx', {
    get () { return window.wx }
  })

  let script = document.createElement('script')

  script.type = 'text/javascript'
  if (options && options.src) {
    script.src = options.src
  } else {
    const isSubscribeUrl = window.location.href.indexOf('launcher-article') !== -1 || window.location.href.indexOf('launcher-article-list') !== -1
    // script.src = 'https://res.wx.qq.com/open/js/jweixin-1.2.0.js'
    script.src = isSubscribeUrl ? 'https://res2.wx.qq.com/open/js/jweixin-1.6.0.js' : 'https://res.wx.qq.com/open/js/jweixin-1.2.0.js'
  }

  script.onload = () => {
    if (window.WeixinJSBridge) {
      this._resolve()
    } else {
      document.addEventListener('WeixinJSBridgeReady', () => {
        this._resolve()
      })
    }
  }

  document.head.appendChild(script)

  Vue.mixin({
    beforeCreate () {
      if (this.$options.wechat) {
        this._wechat = this.$options.wechat
      }
    }
  })
}

